import React from 'react';
import Button from 'react-bootstrap/lib/Button';

import styles from './css/FiltersContainer.module.css';

const FiltersContainer = ({ filtersOptions, currentFilterType, setCurrentFilterType }) => {
    const filterButtons = filtersOptions.map((filterType) => {
        return (
            <Button
                key={filterType.value}
                className={`${styles.searchFiltersButton} ${
                    currentFilterType === filterType.value ? styles.selected : ''
                }`}
                onClick={() => {
                    setCurrentFilterType(filterType.value);
                }}>
                {filterType.buttonText}
            </Button>
        );
    });

    return (
        <>
            {filterButtons.length > 1 && (
                <div className={styles.searchFilters}>
                    <div className={styles.searchFiltersTitle}>Show:</div>
                    <div className={styles.searchFiltersButtons}>{filterButtons}</div>
                </div>
            )}
        </>
    );
};

export default FiltersContainer;
